import type * as React from 'react';
import { get } from '@Domain/Api';
import beneficiaryAccessFetched, {
	type BeneficiaryAccessFetchedAction,
	type BeneficiaryAccessPayload,
} from '@Application/Beneficiaries/Access/Actions/beneficiaryAccessFetched';
import beneficiaryAccessFetchFailed, {
	type BeneficiaryAccessFetchFailedAction,
} from '@Application/Beneficiaries/Access/Actions/beneficiaryAccessFetchFailed';
import type FetchBeneficiaryAccess from '@Application/Beneficiaries/Access/Queries/FetchBeneficiaryAccess';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = BeneficiaryAccessFetchedAction | BeneficiaryAccessFetchFailedAction;

export default (query: FetchBeneficiaryAccess) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await get<{ level: BeneficiaryAccessPayload['level'] }>(
				`${parameters.api.host}/api/accounts/${query.accountId}/beneficiary-access`,
			);

			const action = beneficiaryAccessFetched(query.accountId, response.level);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryAccessFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
